import {
  LearningBudgetService,
  UpdateUserBudgetAmountOpts,
} from '@/services/learning-budget';
import { ApiReactMutationOptions } from '@/types/api';
import { ApiLearningBudgetTransactionsDigestResponse } from '@/types/learning-budget';
import { useMutation } from '@tanstack/react-query';

export function useUserLearningBudgetMutation(
  options?: ApiReactMutationOptions<
    ApiLearningBudgetTransactionsDigestResponse,
    UpdateUserBudgetAmountOpts
  >,
) {
  return useMutation({
    mutationKey: [LearningBudgetService.PATH],
    mutationFn: LearningBudgetService.updateUserBudgetAmount,
    ...options,
  });
}
